export default {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'k',
    million: 'million',
    billion: 'billion',
    trillion: 'trillion'
  },
  currency: {
    symbol: '$'
  }
};
